import React from "react";
import Layout from "../../components/Layout";

const Industries = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow"><span className="dot"></span> Industries</div>
                    <h1>Built for payment businesses</h1>
                    <p>
                        Everest fits merchants, fintechs, PSPs, acquirers, and platforms that need modern payment infrastructure and wallet technology, delivered directly or via partners.
                    </p>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container">
                    <div className="compact-grid">
                        <article className="card">
                            <h3>Merchants</h3>
                            <p>Add new payment methods, support conversion optimisation (depending on implementation and market conditions), and support wallet-enabled customer journeys (where applicable).</p>
                        </article>
                        <article className="card">
                            <h3>Fintechs</h3>
                            <p>Expand into payment acceptance, wallet functionality, and stablecoin-based payments (subject to market and issuer risks) without building the full stack.</p>
                        </article>
                        <article className="card">
                            <h3>PSPs and acquirers</h3>
                            <p>Enable access to more rails and packaging options, and more payment choice to merchants.</p>
                        </article>
                        <article className="card">
                            <h3>Platforms</h3>
                            <p>Embed funding, payment acceptance workflows, and wallet functionality inside the product experience.</p>
                        </article>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <p className="page-disclaimer">
                    Crypto-asset services involve significant risk, including market volatility, liquidity risk, and the potential loss of value.
                    </p>
                </div>
            </section>
        </Layout>
    );
};

export default Industries;
